<template>
  <g id="Seat" v-on:click="changeSeverity('rightSeat')" :class="severityClass">
    <path
      class="cls-706"
      d="M341.49,438.85c-.21,.42-.45,.85-.72,1.28-1.15,1.9-3.07,3.04-5.12,3.04h-40.6c-5.63-.01-11.25-.69-16.75-2.07-4.09-1.02-8.48-2.42-11.34-4.19-1.29-.8-1.66-2.65-.88-3.97,.07-.12,.14-.23,.23-.34l2.89-3.6c.24-.3,.5-.58,.77-.83,.96-.88,2.11-1.48,3.34-1.71,.78-.14,1.73-.27,2.91-.35,3.38-.21,15.28,.36,20.46,.64,1.23,.06,2.45,.32,3.62,.73,.05,.02,.11,.04,.17,.06,.24,.09,.47,.18,.71,.28,.8,.34,1.78,.75,2.86,1.16,.04,.02,.08,.03,.12,.05,2.77,1.04,6.19,2.07,8.81,2.07,4.79,0,18.48,1.44,23.97-2.92,1.12-.89,2.67-.72,3.59,.43,.04,.05,.07,.1,.12,.14,.16,.2,.31,.42,.45,.63,.4,.62,.72,1.28,.95,1.98h0c.82,2.41,.65,5.17-.55,7.49Z"
    />
    <path
      class="cls-1"
      d="M341.09,429.38h0c-.43,1.04-2.23,1.96-3.87,2.62-1.66,.67-3.41,1.03-5.18,1.08-5.72,.18-21.01,.6-25.38-.07-3.54-.55-7.16-2.16-9.24-3.21-1.27-.64-2.62-1-4.01-1.08-5.66-.33-20.12-1.15-21.5-1.02-.68,.06-1.36,.26-1.93,.47,.96-.88,2.11-1.48,3.34-1.71,.78-.14,1.74-.27,2.91-.35,3.38-.21,15.28,.36,20.46,.64,1.54,.08,3.05,.45,4.49,1.07,2.86,1.24,8.09,3.27,11.79,3.27,4.79,0,18.48,1.44,23.97-2.92,1.12-.89,2.67-.72,3.59,.43,.04,.05,.07,.1,.12,.14,.16,.2,.31,.41,.45,.63Z"
    />
    <path
      class="cls-356"
      d="M341.49,438.85c-.22,.42-.46,.85-.72,1.28-1.15,1.9-3.07,3.04-5.12,3.04h-40.6c-5.63-.01-11.25-.69-16.75-2.07-4.09-1.02-8.48-2.43-11.34-4.2-1.29-.8-1.66-2.65-.88-3.97,1.13,1.08,3.28,2.68,6.6,3.42,2.86,.64,7.46,1.51,11.09,2.17,3.56,.64,7.16,.97,10.77,.97h42.03c2.06,0,3.92-1.4,4.66-3.56,.39-1.15,.71-2.64,.8-4.58,.82,2.41,.65,5.17-.55,7.49Z"
    />
    <path
      class="cls-732"
      d="M304.04,428.98c-.58,1.24-2.15,4.82-3.23,8.68l-.54,1.88-1.04,3.63h-4.08c-.01-.07,0-.16,.02-.24l1.05-3.65,.95-3.33c.83-2.89,1.92-5.8,3.12-8.47,.05,.02,.11,.04,.17,.06,.24,.09,.47,.18,.71,.28,.8,.34,1.78,.75,2.86,1.16Z"
    />
    <path
      class="cls-449"
      d="M303.65,428.89c-.25,.54-.73,1.62-1.29,3.01-.64,1.61-1.38,3.64-1.97,5.76l-.52,1.83-.02,.05-1.06,3.7c-.06,.2-.2,.34-.36,.34h-3.35c-.25,0-.41-.33-.32-.65l.99-3.45,.06-.21,.96-3.33c.54-1.87,1.18-3.74,1.89-5.55,.42-1.06,.87-2.11,1.33-3.12,.1-.21,.32-.3,.51-.21l2.97,1.29c.19,.08,.28,.33,.19,.54Z"
    />
    <path
      class="cls-1"
      d="M303.65,428.89c-.25,.54-.73,1.62-1.29,3.01-1.37-.47-2.64-1.01-3.7-1.51,.42-1.06,.87-2.11,1.33-3.12,.1-.21,.32-.3,.51-.21l2.97,1.29c.19,.08,.28,.33,.19,.54Z"
    />
    <path
      class="cls-356"
      d="M299.86,439.49l-.02,.05-1.06,3.7c-.06,.2-.2,.34-.36,.34h-3.35c-.25,0-.41-.33-.32-.65l.99-3.45h4.12Z"
    />
    <rect class="cls-419" x="276.51" y="441.81" width="57.23" height="6.34" />
  </g>
</template>
<script>
export default {
  props: {
    severityClass: String
  },
  methods: {
    changeSeverity(section) {
      this.$emit('changeSeverity', section);
    }
  }
};
</script>
